<template>
  <div
    :class="[
      'nav-bar-main-links',
      {
        'with-badge':
          !isCustomerLead &&
          customerReferral &&
          customerReferral.variation_ui_components.header_nav_badge.is_visible,
      },
    ]"
  >
    <RouterLink
      v-if="isPropertyManager"
      :to="{ name: 'properties' }"
      test-id="properties"
      :class="['link', { 'link-active': getCurrentLink('properties') }]"
      @click.native="onClick"
      >Properties</RouterLink
    >

    <RouterLink
      :to="{ name: 'services' }"
      test-id="services"
      :class="['link', { 'link-active': getCurrentLink('services') }]"
      @click.native="onClick"
      >My Services</RouterLink
    >
    <RouterLink
      v-if="!isCustomerLead"
      :to="{
        name: 'orderService',
      }"
      test-id="order_service"
      :class="['link', { 'link-active': getCurrentLink('orderService') }]"
      @click.native="onClick"
      >Order</RouterLink
    >
    <RouterLink
      v-if="!isCustomerLead"
      :to="{ name: 'support' }"
      test-id="support"
      :class="['link', { 'link-active': getCurrentLink('support') }]"
      @click.native="onClick"
      >Support</RouterLink
    >
    <div
      v-if="
        !isCustomerLead &&
          customerReferral &&
          customerReferral.variation_ui_components.header_nav_button.is_visible
      "
      class="share-wrapper"
      test-id="share-link"
    >
      <RouterLink
        :to="{ name: 'share' }"
        test-id="share"
        :class="['link', { 'link-active': getCurrentLink('share') }]"
        @click.native="onClick"
        >{{ getShareText }}</RouterLink
      >
      <div
        v-if="customerReferral.variation_ui_components.header_nav_badge.is_visible"
        test-id="badge"
        class="badge"
      >
        {{ getBadgeText }}
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import { AUTH__IS_CUSTOMER_LEAD, SHARE__CUSTOMER_REFERRAL } from '@/store/types';
import VueTypes from 'vue-types';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'NavBarMainLinks',
  mixins: [themedComponentMixin],
  props: {
    isPropertyManager: VueTypes.bool.isRequired,
  },
  computed: {
    ...mapState(['featureFlags']),
    ...mapGetters({
      isCustomerLead: [AUTH__IS_CUSTOMER_LEAD],
      customerReferral: [SHARE__CUSTOMER_REFERRAL],
    }),
    getShareText() {
      return `
            ${_.get(
              this.customerReferral,
              'variation_ui_components.header_nav_button.text',
              'Free Services'
            )}`;
    },
    getBadgeText() {
      return `
            ${_.get(
              this.customerReferral,
              'variation_ui_components.header_nav_badge.text',
              'New'
            )}`;
    },
  },
  methods: {
    getCurrentLink(link) {
      return link === this.$route.name;
    },
    onClick() {
      this.$emit('closeMenu');
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-bar-main-links {
  height: 100%;
  display: flex;
  padding-right: 20px;
  cursor: pointer;
}

.with-badge {
  padding-right: 40px;
}

.link {
  display: flex;
  align-items: center;
  height: 100%;
  color: $navbar-links;
  font-size: $size-4;
  font-weight: 600;
  user-select: none;
  padding: 0 10px;
  &:hover {
    color: $white;
  }
}

.link-active {
  color: $white;
}

.share-wrapper {
  position: relative;
}

.badge {
  user-select: none;
  display: flex;
  text-align: justify;
  align-items: center;
  text-transform: uppercase;
  font-size: 0.9rem;
  padding: 0 4px;
  border-radius: 2px;
  height: 17px;
  background-color: $tertiary;
  color: $white;
  position: absolute;
  top: 14px;
  right: -16px;
  font-weight: bold;
}

@media (max-width: $mobile-max-width) {
  .nav-bar-main-links {
    width: 100%;
    padding-top: 12px;
    flex-direction: column;
    align-items: center;
    height: 180px;
    width: 100%;
  }

  .link {
    text-align: center;
    display: block;
    color: $white;
    font-size: $size-2;
    font-weight: normal;
    width: 100%;
    &:hover {
      color: $navbar-links;
    }
  }

  .with-badge {
    padding-right: 0px;
  }

  .badge {
    top: -9px;
    right: -18px;
  }
}

.themed-component {
  .link {
    color: $theme-color-white;
    opacity: 0.5;

    &:hover,
    &.link-active {
      opacity: 1;
    }
  }
}
</style>
